<template>
  <el-col :span="8" class="statistic-graph">
    <el-card class="data" v-loading="loading_video">
      <div slot="header" class="card-header">
          <div class="card-header__title">
            <img class="report-img" src="@/assets/images/videos.svg" alt="" />
            <span>VIDEOS</span>
          </div>
        <div class="card-header__filter">
          <el-select v-model="filter" placeholder="Filter Videos" @change="filterVideos">
            <el-option
                v-for="filter in filters"
                :key="filter"
                :label="filter"
                :value="filter.toLowerCase()">
            </el-option>
          </el-select>
        </div>
        <div class="card-header__total">Total: {{ total }}</div>
      </div>
        <GChart
          class="chart"
          type="ColumnChart"
          :data="video_chart"
          :options="VideoChartSet"
          v-if="video_chart.length > 1"
        />
        <div v-else class="no-data"><span>No Data</span></div>

    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
export default {
  components: {
    GChart
  },

  computed: {
    ...mapState('adminDashboard', ['VideoChartSet', 'loading_video', 'video']),
    ...mapGetters('adminDashboard', ['video_chart']),

    filter: {
      get() {
        return this.$store.getters['adminDashboard/getFilterVideo']
      },
      set(value) {
        this.$store.commit('adminDashboard/setFilterVideo', value)
      }
    },
    total() {
       let total = 0
       this.video.forEach((video) => {
            total+= video.nano + video.micro + video.mid + video.macro + video.elite
       })
      return total
    }
  },

  data() {
    return {
      selectedCommand: 'Date range',
      colors: [
        '#F2F1F1',
        '#B6B0BF',
        '#FFA500'
      ],
      filters: ['All', 'Approved', 'Rejected', 'Pending', 'Free']
    }
  },

  methods: {
    ...mapActions('adminDashboard', ['readVideoData']),

    filterVideos(value) {
      this.readVideoData(value)
    }
  }
}
</script>
